export default {
   REQUEST_DASHBOARD: "REQUEST_DASHBOARD",
   RECEIVE_DASHBOARD: "RECEIVE_DASHBOARD",

   REQUEST_TERMINAL: "REQUEST_TERMINAL",
   RECEIVE_TERMINAL: "RECEIVE_TERMINAL",
   FILTER_TERMINAL: "FILTER_TERMINAL",

   REQUEST_PC_SPECS: "REQUEST_PC_SPECS",
   RECEIVE_PC_SPECS: "RECEIVE_PC_SPECS",
   TOTALROWS_PC_SPECS: "TOTALROWS_PC_SPECS",
   FILTER_PC_SPECS: "FILTER_PC_SPECS",

   REQUEST_INSTALLED_APP_STATUS: "REQUEST_INSTALLED_APP_STATUS",
   RECEIVE_INSTALLED_APP_STATUS: "RECEIVE_INSTALLED_APP_STATUS",
   REQUEST_INSTALLED_APP_DETAIL:"REQUEST_INSTALLED_APP_DETAIL",
   RECEIVE_INSTALLED_APP_DETAIL: "RECEIVE_INSTALLED_APP_DETAIL",

   REQUEST_INSTALLED_INFO_SEARCH: "REQUEST_INSTALLED_INFO_SEARCH",
   RECEIVE_INSTALLED_INFO_SEARCH: "RECEIVE_INSTALLED_INFO_SEARCH",
   REQUEST_INSTALLED_INFO_DETAIL:"REQUEST_INSTALLED_INFO_DETAIL",
   RECEIVE_INSTALLED_INFO_DETAIL: "RECEIVE_INSTALLED_INFO_DETAIL",

   REQUEST_ADAPTER: "REQUEST_ADAPTER",
   RECEIVE_ADAPTER: "RECEIVE_ADAPTER",
   TOTALROWS_ADAPTER: "TOTALROWS_ADAPTER",

   REQUEST_INSTALLED_APP: "REQUEST_INSTALLED_APP",
   RECEIVE_INSTALLED_APP: "RECEIVE_INSTALLED_APP",
   TOTALROWS_INSTALLED_APP: "TOTALROWS_INSTALLED_APP",

   REQUEST_RUNNING_APP: "REQUEST_RUNNING_APP",
   RECEIVE_RUNNING_APP: "RECEIVE_RUNNING_APP",
   TOTALROWS_RUNNING_APP: "TOTALROWS_RUNNING_APP",

   REQUEST_SETTING: "REQUEST_SETTING",
   RECEIVE_SETTING: "RECEIVE_SETTING",
   TOTALROWS_SETTING: "TOTALROWS_SETTING",

   REQUEST_OS_SETTING: "REQUEST_OS_SETTING",
   RECEIVE_OS_SETTING: "RECEIVE_OS_SETTING",

   REQUEST_MANUFACTURER: "REQUEST_MANUFACTURER",
   RECEIVE_MANUFACTURER: "RECEIVE_MANUFACTURER",

   REQUEST_MODEL: "REQUEST_MODEL",
   RECEIVE_MODEL: "RECEIVE_MODEL",

   REQUEST_USER_SETTING: "REQUEST_USER_SETTING",
   RECEIVE_USER_SETTING: "RECEIVE_USER_SETTING",

   REQUEST_DEPARTMENT_SETTING: "REQUEST_DEPARTMENT_SETTING",
   RECEIVE_DEPARTMENT_SETTING: "RECEIVE_DEPARTMENT_SETTING",

   REQUEST_ACCOUNT: "REQUEST_ACCOUNT",
   RECEIVE_ACCOUNT: "RECEIVE_ACCOUNT",
   CREATE_ACCOUNT: "CREATE_ACCOUNT",
   UPDATE_ACCOUNT: "UPDATE_ACCOUNT",
   DELETE_ACCOUNT: "DELETE_ACCOUNT",
   DELETE_ACCOUNT_FAIL: "DELETE_ACCOUNT_FAIL",
   CLOSE_ALERT_DELETE_ACCOUNT: "CLOSE_ALERT_DELETE_ACCOUNT",
   REQUEST_ACCOUNT_FAIL: "REQUEST_ACCOUNT_FAIL",

   REQUEST_USER: "REQUEST_USER",
   RECEIVE_USER: "RECEIVE_USER",
   TOTALROWS_USER: "TOTALROWS_USER",
   FILTER_USER: "FILTER_USER",

   REQUEST_WORK_HISTORY: "REQUEST_WORK_HISTORY",
   RECEIVE_WORK_HISTORY: "RECEIVE_WORK_HISTORY",
   //APIからデータを取得する
   REQUEST_WORK_HISTORY_STATUS: "REQUEST_WORK_HISTORY_STATUS",
   RECEIVE_WORK_HISTORY_STATUS: "RECEIVE_WORK_HISTORY_STATUS",
   CLEAR_WORK_HISTORY_STATUS: "CLEAR_WORK_HISTORY_STATUS",

   REQUEST_WORK_STATUS: "REQUEST_WORK_STATUS",
   RECEIVE_WORK_STATUS: "RECEIVE_WORK_STATUS",
   CLEAR_WORK_STATUS: "CLEAR_WORK_STATUS",

   REQUEST_VERSION: "REQUEST_VERSION",
   RECEIVE_VERSION: "RECEIVE_VERSION",
   TOTALROWS_VERSION: "TOTALROWS_VERSION",

   REQUEST_VERSION_OS: "REQUEST_VERSION_OS",
   RECEIVE_VERSION_OS: "RECEIVE_VERSION_OS",

   REQUEST_VERSION_API: "REQUEST_VERSION_API",
   RECEIVE_VERSION_API: "RECEIVE_VERSION_API",

   LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
   LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
   LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

   REQUEST_FILTER: "REQUEST_FILTER",
   RECEIVE_FILTER: "RECEIVE_FILTER",
   ERROR_FILTER: "ERROR_FILTER",

   REQUEST_FILTER_DATAS: "REQUEST_FILTER_DATAS",
   RECEIVE_FILTER_DATAS: "RECEIVE_FILTER_DATAS",
   ERROR_FILTER_DATAS: "ERROR_FILTER_DATAS",

   LOGOUT: "USERS_LOGOUT",
   RECEIVE_OTP: "RECEIVE_OTP",
   RESEND_OTP: "RESEND_OTP",
   VERIFIED_OTP_FAILED: "VERIFIED_OTP_FAILED",
   LOGIN_UPDATE_MESSAGE: "LOGIN_UPDATE_MESSAGE:",
   SET_FETCH_STATE: "SET_FETCH_STATE",

   REQUEST_TIMEKEEPING: 'REQUEST_TIMEKEEPING',
   RECEIVE_TIMEKEEPING: 'RECEIVE_TIMEKEEPING',

   REQUEST_AI_ASSISTANT: "REQUEST_AI_ASSISTANT",
   RECEIVE_AI_ASSISTANT: "RECEIVE_AI_ASSISTANT",
   DELETE_MSG_AI_ASSISTANT: "DELETE_MSG_AI_ASSISTANT",
   
   REQUEST_APPNAME : 'REQUEST_APPNAME',
   RECEIVE_APPNAME: 'RECEIVE_APPNAME',

   CHANGE_FILTER_DATAS: "CHANGE_FILTER_DATAS",

};
